import axios from 'axios';
import {
  POSTS_LIST, CREATE, CC_UPDATES_LIST, USER_WALL_POSTS, DELETE, DELETESHARED, UPDATESHARED, UPDATE, CREATEMEDIA, DELETEMEDIA, UPDATEMEDIA,
  MEMBER_WALL_POSTS,
} from './types';
import api from '../../../utils/api';
import getIDfromURL from '../../../utils/getIDfromURL';

const apiHost = process.env.VUE_APP_API_HOST;

export default {
  async addPost({ commit }, _post) {
    const postData = _post.data;
    if (_post.customerId) {
      postData.posted_on = `${apiHost}/customers/${_post.customerId}/`;
    }
    const { data } = await axios(api.posts.create(postData));
    commit(CREATE, { post: data });
  },
  async fetchPosts({ commit }, { page, customerId }) {
    const { data } = await axios(api.posts.fetch(page, customerId));

    commit(POSTS_LIST, { posts: data.results, page });
    commit(
      'postsLikeUnlike/ALL_POSTS_LIKES',
      { posts: data.results },
      { root: true },
    );
    return data;
  },
  async fetchSinglePost({}, id) {
    const { data } = await axios(api.posts.fetchSinglePost(id));
    return data;
  },
  async fetchSingleSharedPost({}, id) {
    let { data } = await axios(api.posts.fetchSingleSharedPost(id));
    data = {
      ...data,
      content: data.post_details.content,
      is_shared: true,
      main_user: data.post_details.customer_details.url,
      main_user_details: data.post_details.customer_details,
      posted_on: data.post_details.posted_on,
      share_tagged_customers: data.tagged_customers,
      shared_count: null,
      shared_post_details: data.post_details,
      shared_post_id: getIDfromURL(data.url),
      tags: data.post_details.tags,
    };
    data.shared_post_details.comment_count = data.comment_count;
    return data;
  },
  async shareUserPost({}, data) {
    const response = await axios(api.posts.shareUserPost(data));
    return response;
  },
  async getUserWall({ commit }, { page, customerId }) {
    const { data } = await axios(api.posts.getUserWall(page, customerId));
    commit(USER_WALL_POSTS, { userWall: data.results, page });
    return data;
  },
  async getMemberWall({ commit }, { page, customerId }) {
    const { data } = await axios(api.posts.getMemberWall(page, customerId));
    commit(MEMBER_WALL_POSTS, { memberWall: data.results, page });
    return data;
  },
  async fetchLatestCcUpdates({ commit }, { companyId, startDate, endDate }) {
    const { data } = await axios(api.posts.fetchLatestCcUpdates(companyId, startDate, endDate));
    commit(CC_UPDATES_LIST, { ccUpdates: data.results });
    return data;
  },
  async deletePost({ commit }, postId) {
    await axios(api.posts.deletePost(postId)).then(() => {
      commit(DELETE, { postId });
    });
  },
  async editPost({ commit }, post) {
    const { data } = await axios(api.posts.update(post));
    commit(UPDATE, data);
    return data;
  },
  async createPostMedia({ commit }, post) {
    const { data } = await axios(api.posts.createPostMedia(post));
    commit(CREATEMEDIA, data);
    return data;
  },
  async editPostMedia({ commit }, post) {
    const { data } = await axios(api.posts.updatePostMedia(post));
    commit(UPDATEMEDIA, data);
    return data;
  },
  async deletePostMedia({ commit }, { id, post, url }) {
    await axios(api.posts.deletePostMedia(id));
    commit(DELETEMEDIA, { id, post, url });
  },
  async editSharedPost({ commit }, post) {
    const { data } = await axios(api.posts.updateShared(post));
    commit(UPDATESHARED, data);
    return data;
  },
  async deleteSharedPost({ commit }, postId) {
    await axios(api.posts.deleteSharedPost(postId)).then(() => {
      commit(DELETESHARED, { postId });
    });
  },
  async getUsersSharedThePost ({ }, { post }) {
   const { data } = await axios(api.posts.getUsersSharedThePost(post));
    return data;
  },
  adjustWallPosts({ commit }, { posts, page }) {
    commit(USER_WALL_POSTS, { userWall: posts, page });
  },
  async reportPost({}, { reason, postUrl }) {
    const { data } = await axios(api.posts.reportPost(reason, postUrl));
    return data;
  }
};
